import type { UseQueryOptions } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { handleResponseThrowError } from '@/_utils/services';
import { apiClient } from '@/_config/lib/axios/api-client';
import type { PreRegisterInfoProps } from '../types';
import { GET_DELIVERYMAN_PRE_REGISTER } from '../constants';

type ParamsProps = {
  deliverymanId: string;
};

const getDeliverymanPreRegister = (params: ParamsProps) => {
  const { deliverymanId } = params || {};

  return apiClient
    .get<PreRegisterInfoProps>(
      `entregadores/${deliverymanId}/pre-registration-infos`,
    )
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

type GetDeliverymanPreRegister = Awaited<
  ReturnType<typeof getDeliverymanPreRegister>
>;

export const useGetDeliverymanPreRegister = (
  params: ParamsProps,
  options: Omit<
    UseQueryOptions<
      GetDeliverymanPreRegister,
      unknown,
      GetDeliverymanPreRegister,
      (string | ParamsProps)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_DELIVERYMAN_PRE_REGISTER, params],
    queryFn: () => getDeliverymanPreRegister(params),
    ...options,
  });
};
